import { Price } from '@webapp/core/components/Price'
import { type Currency, type OrderItemTax } from '@webapp/models'
import { WithTaxTooltip } from '../WithTaxTooltip'

const CURRENCY_BASE_RATE = 1

export interface ITableTaxFieldProps {
  taxes: OrderItemTax[]
  currency: Currency
  taxAmount: number | string
  showCurrency?: boolean
}

export const TableTaxField = ({
  taxes,
  taxAmount,
  currency,
  showCurrency = true,
}: ITableTaxFieldProps) => {
  const hideCurrency =
    currency?.base ||
    Number(currency?.rate) === CURRENCY_BASE_RATE ||
    !currency?.rate ||
    !showCurrency

  return (
    <WithTaxTooltip
      taxes={taxes}
      price={taxAmount}
      currency={hideCurrency ? null : currency}
      isDisabled={!taxes?.length}
    >
      <Price price={taxAmount} currency={currency.name} />
    </WithTaxTooltip>
  )
}

TableTaxField.displayName = 'TableTaxField'
